// eRecords icon set: outline icons on a 24px grid with a 1.8 stroke, after
// Tabler Icons (MIT), the same family concierge-ui uses.
//
// esbuild-icons.js points every `@mui/icons-material` import in the app at
// this module. Names defined here replace the MUI glyph, the remaining used
// filled icons map to their MUI "Outlined" variant, and anything else falls
// through to MUI unchanged, so upstream components need no edits.
//
// The `export *` below and the named exports after it overlap on purpose: per
// the ES module spec a module's own export wins over a star re-export, which
// is exactly the override this file exists for. import/export flags every
// overlap as an error, so it is turned off for this file only.
/* eslint-disable import/export */
import React from 'react'
import { createSvgIcon } from '@mui/material/utils'

export * from '@mui/icons-material'

function stroke(d: string, name: string): ReturnType<typeof createSvgIcon> {
  return createSvgIcon(
    <path
      d={d}
      fill='none'
      stroke='currentColor'
      strokeWidth={1.8}
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    name,
  )
}

function filled(d: string, name: string): ReturnType<typeof createSvgIcon> {
  return createSvgIcon(
    <path
      d={d}
      fill='currentColor'
      stroke='currentColor'
      strokeWidth={1.8}
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    name,
  )
}

const P = {
  bell: 'M10 5a2 2 0 1 1 4 0 7 7 0 0 1 4 6v3a4 4 0 0 0 2 3H4a4 4 0 0 0 2-3v-3a7 7 0 0 1 4-6M9 17v1a3 3 0 0 0 6 0v-1',
  circle: 'M3 12a9 9 0 1 0 18 0 9 9 0 1 0-18 0',
  chevronDown: 'M6 9l6 6 6-6',
  chevronUp: 'M6 15l6-6 6 6',
  heart: 'M19.5 12.572L12 20l-7.5-7.428A5 5 0 1 1 12 6.006a5 5 0 1 1 7.5 6.572',
  phone:
    'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2',
  refresh:
    'M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2M20 19v-4h-4',
  triangle:
    'M12 9v4M12 16v.01M10.363 3.591L2.257 17.125a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636-2.87L13.637 3.59a1.914 1.914 0 0 0-3.274 0z',
  user: 'M8 7a4 4 0 1 0 8 0 4 4 0 0 0-8 0M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2',
  users:
    'M5 7a4 4 0 1 0 8 0 4 4 0 1 0-8 0M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2M16 3.13a4 4 0 0 1 0 7.75M21 21v-2a4 4 0 0 0-3-3.85',
  x: 'M18 6L6 18M6 6l12 12',
}

// navigation
export const Dashboard = stroke(
  'M5 4h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1M5 16h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1M15 12h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1M15 4h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1',
  'Dashboard',
)
export const Notifications = stroke(P.bell, 'Notifications')
export const NotificationsActive = stroke(
  P.bell +
    'M21 6.727A11.05 11.05 0 0 0 18.206 3M3 6.727A11.05 11.05 0 0 1 5.792 3',
  'NotificationsActive',
)
export const NotificationsOffOutlined = stroke(
  'M9.346 5.353A2 2 0 0 1 14 5a7 7 0 0 1 4 6v3M17 17H4a4 4 0 0 0 2-3v-3a7 7 0 0 1 1.268-3.88M9 17v1a3 3 0 0 0 6 0v-1M3 3l18 18',
  'NotificationsOffOutlined',
)
export const RotateRight = stroke(
  'M4.05 11a8 8 0 1 1 .5 4M4 20v-5h5',
  'RotateRight',
)
export const Today = stroke(
  'M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zM16 3v4M8 3v4M4 11h16M8 15h2v2H8z',
  'Today',
)
export const Layers = stroke(
  'M12 4L4 8l8 4 8-4-8-4M4 12l8 4 8-4M4 16l8 4 8-4',
  'Layers',
)
export const VpnKey = stroke(
  'M3 7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zM3 15a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zM7 8v.01M7 16v.01',
  'VpnKey',
)
export const Group = stroke(P.users, 'Group')
export const Build = stroke(
  'M7 10h3V7L6.5 3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1-3 3l-6-6a6 6 0 0 1-8-8L7 10',
  'Build',
)
export const Settings = stroke(
  'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066-2.573c-.94-1.543.826-3.31 2.37-2.37 1 .608 2.296.07 2.572-1.065zM9 12a3 3 0 1 0 6 0 3 3 0 0 0-6 0',
  'Settings',
)
export const Menu = stroke('M4 6h16M4 12h16M4 18h16', 'Menu')
export const Logout = stroke(
  'M14 8V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-2M9 12h12l-3-3M18 15l3-3',
  'Logout',
)
export const OpenInNew = stroke(
  'M12 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6M11 13l9-9M15 4h5v5',
  'OpenInNew',
)

export const Assessment = stroke(
  'M14 3v4a1 1 0 0 0 1 1h4M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2zM9 17v-5M12 17v-1M15 17v-3',
  'Assessment',
)

// people and contact
export const Person = stroke(P.user, 'Person')
export const PersonAdd = stroke(
  'M8 7a4 4 0 1 0 8 0 4 4 0 0 0-8 0M16 19h6M19 16v6M6 21v-2a4 4 0 0 1 4-4h4',
  'PersonAdd',
)
export const PersonRemove = stroke(
  'M8 7a4 4 0 1 0 8 0 4 4 0 0 0-8 0M6 21v-2a4 4 0 0 1 4-4h4M16 19h6',
  'PersonRemove',
)
export const GroupAdd = stroke(
  'M5 7a4 4 0 1 0 8 0 4 4 0 1 0-8 0M3 21v-2a4 4 0 0 1 4-4h4c.96 0 1.84.338 2.53.901M16 19h6M19 16v6',
  'GroupAdd',
)
export const PhoneInTalk = stroke(
  P.phone + 'M15 7a2 2 0 0 1 2 2M15 3a6 6 0 0 1 6 6',
  'PhoneInTalk',
)
export const SettingsPhone = stroke(P.phone, 'SettingsPhone')
export const Phone = stroke(P.phone, 'Phone')
export const Forum = stroke('M4 5h11v8H8l-4 3zM15 9h5v8l-3-2h-6v-2', 'Forum')
export const Sms = stroke(
  'M8 9h8M8 13h6M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-5l-5 3v-3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h12z',
  'Sms',
)
export const Email = stroke(
  'M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM3 7l9 6 9-6',
  'Email',
)
export const Webhook = stroke(
  'M4.876 13.61A4 4 0 1 0 11 17h6M19.2 12.8a4 4 0 1 0-4.96-5.84l-2.98 5.04M10.89 6.08a4 4 0 1 0-5.06 5.9l2.96 5.02',
  'Webhook',
)
export const LockOpen = stroke(
  'M5 13a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zM11 16a1 1 0 1 0 2 0 1 1 0 0 0-2 0M8 11V7a4 4 0 0 1 8 0',
  'LockOpen',
)

// actions
export const Add = stroke('M12 5v14M5 12h14', 'Add')
export const Remove = stroke('M5 12h14', 'Remove')
export const Edit = stroke(
  'M4 20h4L18.5 9.5a2.828 2.828 0 1 0-4-4L4 16v4M13.5 6.5l4 4',
  'Edit',
)
export const Delete = stroke(
  'M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3',
  'Delete',
)
export const Close = stroke(P.x, 'Close')
export const Clear = stroke(P.x, 'Clear')
export const Check = stroke('M5 12l5 5L20 7', 'Check')
export const Search = stroke(
  'M3 10a7 7 0 1 0 14 0 7 7 0 1 0-14 0M21 21l-6-6',
  'Search',
)
export const FilterList = stroke('M4 6h16M7 12h10M10 18h4', 'FilterList')
export const Download = stroke(
  'M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12',
  'Download',
)
export const Sync = stroke(P.refresh, 'Sync')
export const Replay = stroke(P.refresh, 'Replay')
export const DragIndicator = stroke(
  'M9 6h.01M9 12h.01M9 18h.01M15 6h.01M15 12h.01M15 18h.01',
  'DragIndicator',
)
export const MoreHoriz = stroke(
  'M4 12a1 1 0 1 0 2 0 1 1 0 1 0-2 0M11 12a1 1 0 1 0 2 0 1 1 0 1 0-2 0M18 12a1 1 0 1 0 2 0 1 1 0 1 0-2 0',
  'MoreHoriz',
)
export const AddAlarm = stroke(
  'M5 13a7 7 0 1 0 14 0 7 7 0 1 0-14 0M7 4L4.25 6M17 4l2.75 2M10 13h4M12 11v4',
  'AddAlarm',
)
export const Schedule = stroke(P.circle + 'M12 7v5l3 3', 'Schedule')
export const PauseCircle = stroke(P.circle + 'M10 9v6M14 9v6', 'PauseCircle')
export const Visibility = stroke(
  'M10 12a2 2 0 1 0 4 0 2 2 0 1 0-4 0M21 12c-2.4 4-5.4 6-9 6s-6.6-2-9-6c2.4-4 5.4-6 9-6s6.6 2 9 6',
  'Visibility',
)
export const VisibilityOff = stroke(
  'M10.585 10.587a2 2 0 0 0 2.829 2.828M16.681 16.673A8.717 8.717 0 0 1 12 18c-3.6 0-6.6-2-9-6 1.272-2.12 2.712-3.678 4.32-4.674m2.86-1.146A9.055 9.055 0 0 1 12 6c3.6 0 6.6 2 9 6-.666 1.11-1.379 2.067-2.138 2.87M3 3l18 18',
  'VisibilityOff',
)
export const Favorite = filled(P.heart, 'Favorite')
export const FavoriteBorder = stroke(P.heart, 'FavoriteBorder')

export const Folder = stroke(
  'M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2',
  'Folder',
)
export const InsertDriveFile = stroke(
  'M14 3v4a1 1 0 0 0 1 1h4M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z',
  'InsertDriveFile',
)
const ImageIcon = stroke(
  'M15 8h.01M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zM3 16l5-5c.928-.893 2.072-.893 3 0l5 5M14 14l1-1c.928-.893 2.072-.893 3 0l3 3',
  'Image',
)
export { ImageIcon as Image }
export const ContentCopy = stroke(
  'M8 10a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2zM16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2',
  'ContentCopy',
)

// arrows and chevrons
export const ExpandMore = stroke(P.chevronDown, 'ExpandMore')
export const KeyboardArrowDown = stroke(P.chevronDown, 'KeyboardArrowDown')
export const ArrowDropDown = stroke('M8 10l4 4 4-4', 'ArrowDropDown')
export const ExpandLess = stroke(P.chevronUp, 'ExpandLess')
export const KeyboardArrowUp = stroke(P.chevronUp, 'KeyboardArrowUp')
export const ChevronLeft = stroke('M15 6l-6 6 6 6', 'ChevronLeft')
export const ChevronRight = stroke('M9 6l6 6-6 6', 'ChevronRight')
export const ArrowUpward = stroke('M12 5v14M18 11l-6-6M6 11l6-6', 'ArrowUpward')
export const ArrowDownward = stroke(
  'M12 5v14M18 13l-6 6M6 13l6 6',
  'ArrowDownward',
)

// status
export const Info = stroke(P.circle + 'M12 9h.01M11 12h1v4h1', 'Info')
export const InfoOutlined = Info
const ErrorIcon = stroke(P.circle + 'M12 8v4M12 16h.01', 'Error')
export { ErrorIcon as Error, ErrorIcon as ErrorOutline }
export const Warning = stroke(P.triangle, 'Warning')
export const WarningAmberOutlined = Warning
export const CheckCircleOutline = stroke(
  P.circle + 'M9 12l2 2 4-4',
  'CheckCircleOutline',
)

// theme picker
export const DarkMode = stroke(
  'M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446A9 9 0 1 1 12 2.992z',
  'DarkMode',
)
export const LightMode = stroke(
  'M8 12a4 4 0 1 0 8 0 4 4 0 1 0-8 0M3 12h1M12 3v1M20 12h1M12 20v1M5.6 5.6l.7.7M18.4 5.6l-.7.7M17.7 17.7l.7.7M6.3 17.7l-.7.7',
  'LightMode',
)
export const SettingsBrightness = stroke(
  P.circle + 'M12 3v18M12 9l4.65-4.65M12 14.3l7.37-7.37M12 19.6l8.85-8.85',
  'SettingsBrightness',
)
export const Palette = stroke(
  'M12 21a9 9 0 0 1 0-18c4.97 0 9 3.582 9 8 0 1.06-.474 2.078-1.318 2.828S17.693 15 16.5 15H14a2 2 0 0 0-1 3.75A1.3 1.3 0 0 1 12 21M7.5 10.5a1 1 0 1 0 2 0 1 1 0 1 0-2 0M11.5 7.5a1 1 0 1 0 2 0 1 1 0 1 0-2 0M15.5 10.5a1 1 0 1 0 2 0 1 1 0 1 0-2 0',
  'Palette',
)

// the rest of the filled icons the app uses: MUI's outlined variants
export { default as AutoFixHigh } from '@mui/icons-material/AutoFixHighOutlined'
export { default as BrokenImage } from '@mui/icons-material/BrokenImageOutlined'
export { default as CompareArrows } from '@mui/icons-material/CompareArrowsOutlined'
export { default as DeveloperBoard } from '@mui/icons-material/DeveloperBoardOutlined'
export { default as PlaylistAdd } from '@mui/icons-material/PlaylistAddOutlined'
export { default as PlaylistRemove } from '@mui/icons-material/PlaylistRemoveOutlined'
export { default as SentimentDissatisfied } from '@mui/icons-material/SentimentDissatisfiedOutlined'
export { default as SentimentVeryDissatisfied } from '@mui/icons-material/SentimentVeryDissatisfiedOutlined'
export { default as ThumbDownOffAlt } from '@mui/icons-material/ThumbDownOffAltOutlined'
